import { BrowserRouter as Router, Route } from "react-router-dom";
import CustomSwitch from "./components/layout/CustomSwitch"
import { ThemeProvider } from "@material-ui/core/styles"
import { theme } from "./theme"
import LandingPage from "./pages/LandingPage";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Account from "./pages/account";
import Dashboard from "./pages/dashboard";
import Subjects from "./pages/subjects";
import ViewSubject from "./pages/subjects/view";
import Library from "./pages/library";
import Announcements from "./pages/announcements";
import ViewAnnouncement from "./pages/announcements/[id]";
import Forum from "./pages/forum";
import Assignments from "./pages/assignments";
import AssignmentInstructions from "./pages/assignments/view";
import AssignmentSubmit from "./pages/assignments/submit";
import Examination from "./pages/examination";
import ExamInstructions from "./pages/examination/instructions";
import ExamQuestions from "./pages/examination/questions";
import Results from "./pages/results";
import ViewResult from "./pages/results/view";
import Calendar from "./pages/calendar";
import Support from "./pages/support";
import AccoountEditScreen from "./pages/account/edit";
import AccountNotificationScreen from "./pages/account/notifications";
import AccountChangePasswordScreen from "./pages/account/change-password";
import AccountProfilePrivacy from "./pages/account/profile-privacy";

import { TeacherDashboard, TeacherAccount, TeacherAccountChangePassword, TeacherAccountNotifications, TeacherEditAccount, TeacherProfilePrivacy, TeacherSubjectList, TeacherLibrary, TeacherSupport, TeacherCalendar, TeacherResults, TeacherExamination, TeacherAssignments, TeacherLibraryUpload, TeacherAnnouncements, TeacherViewAnnouncements, TeacherAnnouncementCreate, TeacherAssignmentCreate, TeacherAssignmentView, TeacherAssignmentUpload, TeacherExaminationCreate, TeacherExaminationView, TeacherResultsView, TeacherResultsUpload } from "./pages/teacher";
import { AdminDashboard, AdminSchools, AdminInstructors, AdminAddInstructor, AdminStudents, AdminAddStudent, AdminSubjects, AdminTimeTables, AdminSystemSettings, AdminSchoolSettings, AdminSupport, AdminSupportMakeAnnouncement, AdminSupportViewTicket } from "./pages/admin";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <CustomSwitch>
          <Route exact path='/' component={LandingPage} />
          <Route exact path='/register' component={Register} />
          <Route exact path='/login' component={Login} />
          <Route exact path='/forgot-password' component={ForgotPassword} />

          {/* ACCOUNT */}
          <Route exact path='/account' component={Account} />
          <Route exact path='/account/edit' component={AccoountEditScreen} />
          <Route exact path='/account/notifications' component={AccountNotificationScreen} />
          <Route exact path='/account/change-password' component={AccountChangePasswordScreen} />
          <Route exact path='/account/profile-privacy' component={AccountProfilePrivacy} />
          <Route exact path={`/student/dashboard`} component={Dashboard} />
          <Route exact path={`/student/subjects`} component={Subjects} />
          <Route exact path={`/student/subjects/view`} component={ViewSubject} />
          <Route exact path={`/student/library`} component={Library} />

          {/* ANNOUNCEMENT */}
          <Route exact path={`/student/announcements`} component={Announcements} />
          <Route exact path={`/student/announcements/single`} component={ViewAnnouncement} />
          <Route exact path={`/student/Forum`} component={Forum} />
          <Route exact path={`/student/assignments`} component={Assignments} />
          <Route exact path={`/student/assignments/view`} component={AssignmentInstructions} />
          <Route exact path={`/student/assignments/submit`} component={AssignmentSubmit} />
          <Route exact path={`/student/examination`} component={Examination} />
          <Route exact path={`/student/examination/instructions`} component={ExamInstructions} />
          <Route exact path={`/student/examination/start`} component={ExamQuestions} />
          <Route exact path={`/student/results`} component={Results} />
          <Route exact path={`/student/results/view`} component={ViewResult} />
          <Route exact path={`/student/calendar`} component={Calendar} />
          <Route exact path={`/student/support`} component={Support} />

          {/* TEACHER ROUTES */}
          <Route exact path={`/teacher/account`} component={TeacherAccount} />
          <Route exact path={`/teacher/account/edit`} component={TeacherEditAccount} />
          <Route exact path={`/teacher/account/profile-privacy`} component={TeacherProfilePrivacy} />
          <Route exact path={`/teacher/account/notifications`} component={TeacherAccountNotifications} />
          <Route exact path={`/teacher/account/change-password`} component={TeacherAccountChangePassword} />
          <Route exact path={`/teacher/dashboard`} component={TeacherDashboard} />
          <Route exact path={`/teacher/subjects`} component={TeacherSubjectList} />
          <Route exact path={`/teacher/library`} component={TeacherLibrary} />
          <Route exact path={`/teacher/library/upload`} component={TeacherLibraryUpload} />
          <Route exact path={`/teacher/announcements`} component={TeacherAnnouncements} />
          <Route exact path={`/teacher/announcements/create`} component={TeacherAnnouncementCreate} />
          <Route exact path={`/teacher/announcements/single`} component={TeacherViewAnnouncements} />
          <Route exact path={`/teacher/assignments`} component={TeacherAssignments} />
          <Route exact path={`/teacher/assignments/create`} component={TeacherAssignmentCreate} />
          <Route exact path={`/teacher/assignments/view`} component={TeacherAssignmentView} />
          <Route exact path={`/teacher/assignments/upload`} component={TeacherAssignmentUpload} />
          <Route exact path={`/teacher/examination`} component={TeacherExamination} />
          <Route exact path={`/teacher/examination/create`} component={TeacherExaminationCreate} />
          <Route exact path={`/teacher/examination/view`} component={TeacherExaminationView} />
          <Route exact path={`/teacher/results`} component={TeacherResults} />
          <Route exact path={`/teacher/results/view`} component={TeacherResultsView} />
          <Route exact path={`/teacher/results/upload`} component={TeacherResultsUpload} />
          <Route exact path={`/teacher/calendar`} component={TeacherCalendar} />
          <Route exact path={`/teacher/support`} component={TeacherSupport} />

          {/* ADMIN ROUTES */}
          <Route exact path={`/admin/dashboard`} component={AdminDashboard} />
          <Route exact path={`/admin/schools`} component={AdminSchools} />
          <Route exact path={`/admin/instructors`} component={AdminInstructors} />
          <Route exact path={`/admin/instructors/add`} component={AdminAddInstructor} />
          <Route exact path={`/admin/students`} component={AdminStudents} />
          <Route exact path={`/admin/students/add`} component={AdminAddStudent} />
          <Route exact path={`/admin/subjects`} component={AdminSubjects} />
          <Route exact path={`/admin/timetables`} component={AdminTimeTables} />
          <Route exact path={`/admin/settings`} component={AdminSystemSettings} />
          <Route exact path={`/admin/settings/school-settings`} component={AdminSchoolSettings} />
          <Route exact path={`/admin/support`} component={AdminSupport} />
          <Route exact path={`/admin/support/make-announcement`} component={AdminSupportMakeAnnouncement} />
          <Route exact path={`/admin/support/ticket`} component={AdminSupportViewTicket} />
        </CustomSwitch>
      </Router>
    </ThemeProvider>
  );
}

export default App;
